import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0eb63bc7"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StoryblokComponent: require('/opt/build/repo/components/Storyblok/Component.vue').default,ElementsSlider: require('/opt/build/repo/components/Elements/Slider.vue').default,LayoutContainer: require('/opt/build/repo/components/Layout/Container/index.vue').default})
